import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Field, reduxForm, change } from 'redux-form';
import { Button, FormGroup, Col, Panel } from 'react-bootstrap';

import Uploader from './Uploader';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';
import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';

import Link from '../../Link';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';

import s from './AddPopularLocationManagement.css';
import bt from '../../../components/commonStyle.css';
class AddPopularLocationManagement extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    formatMessage: PropTypes.func,
    initialValues: PropTypes.object,
  };

  static defaultProps = {
    data: []
  };

  onSuggestSelect = (data, value) => {
    const { change } = this.props;
    if (value) {
      change('locationAddress', value);
    }
  }

  onTextChange = (value) => {
    const { change } = this.props;
    if (value !== undefined && value?.trim() === '') {
      change('locationAddress', value);
    }
  }

  renderPlacesSuggest = ({ input, label, meta: { touched, error }, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={bt.space3}>
        <label className={cx(bt.commonLabelText, 'textWhite')}>{label}</label>
        <PlaceGeoSuggest
          {...input}
          placeholder={label}
          className={cx(bt.commonControlInput, s.popularLocationGeoSuggestion, 'newGeoSuggestInput')}
          onSuggestSelect={this.onSuggestSelect}
          onChange={this.onTextChange}
          id={'addPopular'}
          containerClass={'geoSuggestPopularContainer'}
        />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </FormGroup>
    )
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { error, handleSubmit, submitting } = this.props;
    return (
      <div className={cx(s.pagecontentWrapper, 'addpopular-autocomplete', 'pagecontentAR', 'popularLocationContainer')}>
        <h1 className={s.headerTitle}><FormattedMessage {...messages.addPopularLocation} /></h1>
        <Col xs={12} sm={12} md={9} lg={8} className={s.blockcenter}>
          <div className={cx(s.space4, bt.textAlignRight, 'textAlignLeftRtl')}>
            <Link to={'/siteadmin/popularlocation'} className={cx(bt.btnPrimaryBorder, bt.btnLarge, bt.noTextDecoration, 'bgBlack')}>
              <FormattedMessage {...messages.goBack} />
            </Link>
          </div>
          <Panel className={cx(s.panelHeader, 'bgBlack', s.mobilePadding)}>
            <form onSubmit={handleSubmit(submit)}>
              {error && <strong>{formatMessage(error)}</strong>}
              <FormGroup className={bt.space3}>
                <label className={s.labelTextNew} ><FormattedMessage {...messages.imageLabel} /></label>
                <Uploader />
              </FormGroup>
              <Field name="location"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.location)}
                inputClass={bt.commonControlInput}
              />
              <Field
                name="locationAddress" type="text"
                component={this.renderPlacesSuggest} label={formatMessage(messages.locationAddress)}

              />
              <div className={cx(bt.textAlignRight, 'textAlignLeftRtl')}>
                <Button className={cx(bt.button, bt.btnPrimary, bt.btnlarge)} type="submit" disabled={submitting} >
                  <FormattedMessage {...messages.save} />
                </Button>
              </div>
            </form>
          </Panel>
        </Col>
      </div>
    );
  }
}

AddPopularLocationManagement = reduxForm({
  form: 'AddPopularLocation', // a unique name for this form
  validate
})(AddPopularLocationManagement);

const mapState = (state) => ({});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AddPopularLocationManagement)));